var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":"Kontakta oss","pace":"6"}},[_vm._v(" Undrar du över något, tveka inte att höra av dig till oss. Vi svarar gärna på dina frågor, och berättar mer om Avtala. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }